module.exports = "/virtual-football-league/img/amblems/right/Italy/Fake_Juventus.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/virtual-football-league/img/amblems/right/Italy/Fake_Juventus.png
// module id = 2144
// module chunks = 4